import Vue from 'vue'
import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css' // import the croppie css manually

Vue.use(VueCroppie)
